var commitDate = '201908211325';

window.gs = window.gs || {};
var martDlvpInfocompdate = '20190321';

/**
 * [GS FRESH 입점 패널] by leesj83 마트 배송지 정보  
 */

(function($){
	"use strict";
	
	var gsf_tq_placeholder;
	
	$('#gsf_tq')
		.focus(function(e){
			gsf_tq_placeholder = $(this).attr('placeholder');
			$(this).attr('placeholder', '');
		})
		.blur(function(e){
		    $(this).attr('placeholder', gsf_tq_placeholder);
		});
    	
    $('#gsf_tq').on('keyup keydown', function(e){
    	var ev = event || window.event;
		var keyCode = ev.which || ev.keyCode;
		
		if(ev.type == 'keydown') {
			switch(keyCode) {
			case 38: //위쪽 방향키
			case 40: //아래쪽 방향키
			case 191: //슬래시, 물음표
			case 222: //따옴표, 큰따옴표
				return false;
			}
		} else {
			switch(keyCode) {
			case 13: //엔터
				fnGsfSearch();
				return false;
			}
		}
    });
    
    $('#martSearchSubmit').click(function(e){
    	fnGsfSearch();
    });
    
    // 배송지 변경
	$("#btn-mart-dlvp-dlv").click(function(e){
		e.preventDefault();
		var w = 470;
		var h = 700;
		var x = (screen.availWidth - w )  / 2;
		var y = (screen.availHeight - h ) / 2;
		var supCd = $(this).data("supcd");
		var dlvpModPopupUrl = "/cust/popup/gsMartAddr.gs?supCd="+supCd;
		LSeqUtil.clickLseqSend("W900001-ADDRESS_CHANGE"); // 배송지 변경 효율코드
		var win = window.open(dlvpModPopupUrl,'martDlvpDlvPop','toolbar=0,location=no,directories=0,status=0,menubar=0,scrollbars=0,resizable=0,left='+ x + ',top=' + y + ',width=' + w + ',height='+ h);
		win.focus();			
	});

	// 배송시간 조회 슬롯
	$("#btn-mart-dlv-slot").click(function(e){
		e.preventDefault();
		var supCd = $(this).data("supcd");
		var url = "/shop/mart/ajaxMartDlvSlot.gs?supCd=" + supCd+"&lseq=W900001-ETA";
		
		$.ajax({
			headers: { "cache-control": "no-cache","pragma": "no-cache" },
			url : url,
			type : 'get',			
			success : function(data) {
				if(data.webError){
					alert(data.webError.errorMessage);
					//쿠키에 저장되어 있는 지점 정보가 정상적이지 않아서 쿠키 삭제된 상태
					if(data.webError.errorCode == "BSHOPF020"){
						location.reload();
					}
				}else{
					if($("#modal-deli").length > 0){
						$("#modal-deli").remove();
					}
					$('body').append(data);
					openLayer('#modal-deli');
				}
				return;
			}	
		});		
		
	});	
	
	$("#btn-mart-usg").click(function(e){
		e.preventDefault();
		var html = '';
			html += '<article id="modal-usg" class="modal-layer" style="position: fixed; left: 50%; top: 50%; margin-left: -240px; margin-top: -108px; z-index: 2500; opacity: 1; display: block;">';
			html += '	<header>';
			html += '		<h1>이용안내</h1>'; 
			html += '	</header>';
			html += '	<main>';
			html += '		<p class="pdt15">GS 프레시몰 상품을 주문하시려면, <strong>배송지를 먼저 선택</strong>하셔야 합니다.</p>';
			html += '		<ul class="mgt20">';
			html += '			<li class="blst-square">현재 표시되는 상품은 GS 프레시몰 ‘강서센터’의 가격으로 선택하신 배송지(배송지점)에 따라 상품의 준비상태 및 가격이 달라질 수 있습니다.</li>';
			html += '			<li class="blst-square">일부 지역은 배송이 불가능할 수 있습니다.</li>';
			html += '		</ul>';
			html += '	</main>'; 
			html += '	<button class="close-btn g" onclick="closeLayer(\'#modal-usg\')">닫기</button>';
			html += '</article>';
		if($("#modal-usg").length <= 0){
			$('body').append(html);
		}

		//효율 코드(배송지 이용안내)
		LSeqUtil.clickLseqSend(fnGetUrlLseq("417144,417182,417193"));

		openLayer('#modal-usg');
	});


	$("#btn-mart-dlv-login").click(function(e) {
		e.preventDefault();
		var lseq = fnGetUrlLseq("417143,417181,417192");
		ShopBase.redirect.loginPage({lseq:lseq});
	});

	$(document).on("click", "#dim", function(){
		closeLayer('.modal-layer');
	});

	// 새벽배송 셀렉트박스
	if($('.dropdown-list').length) {
		$('.dropdown-list .dropdown-trigger').not('.dropdown-icon').on('click', function(){
			var _this = $(this);
			var _active = _this.parents('.dropdown-list').find('.dropdown-trigger.active');
			var _activeText = _this.children('.dropdown-text').text();
			if(_this.hasClass('active')) {
				_this.siblings('.dropdown-content').addClass('open');
			} else {
				_active.find('.dropdown-text').text(_activeText);
				_this.parents('.dropdown-content').removeClass('open');
				_this.parents('.dropdown-content').find('.dropdown-trigger').removeClass('on');
				_this.addClass('on');
			}
			
			if(_active.data("martdeliflag") != _this.data("martdeliflag")){
                GsBase.Cookie.set("martDeliFlag", _this.data("martdeliflag"));						// 화면에 노출할 배송 구분 값
    			GsBase.Cookie.set("martDeliHistoryFlag", _this.data("martdeliflag"), 365);			// 마지막 선택한 배송 구분 값 저장
				location.href = "/shop/mart/main.gs?lsectid=1453884&lseq="+_this.data("lseq");
			}
		});
		$('.dropdown-icon').on('click', function(){
			if($('.dropdown-content').hasClass('open')) {
				$('.dropdown-content').removeClass('open');
			}else{
				$('.dropdown-content').addClass('open');
			}
		});

	}

	/*if($("#martDeliFlag").length > 0 && $("#martDeliFlag").val() != "") {
		var martDeliFlag = $("#martDeliFlag").val();
		if(martDeliFlag == "D") {
			var gssuper = GsBase.Cookie.get("gssuper");
			if (gssuper != undefined && "" != gssuper) {
				var gssuperDcFlag = true;
				try {
					var gssuperArray = gssuper.split("~");
					if (gssuperArray.length > 3) {
						var gssuperDcArray = gssuperArray[4].split("=");
						if (gssuperDcArray.length > 1 && "" != gssuperDcArray[1]) {
							gssuperDcFlag = false;
						}
					}
				} catch (e) {

				}
				//셋팅
				if (gssuperDcFlag) {
					martDeliFlag = "A";
				}
			} else {    
			    //당일 배송 셋팅
				martDeliFlag = "A";
			}
		}
		GsBase.Cookie.set("martDeliFlag", martDeliFlag);
	}*/
})(jQuery);

function fnGsfSearch() {
	var $gsf_tq = $('#gsf_tq');
	var gsf_tq_val = $gsf_tq.val();
	if(!gsf_tq_val) {
		alert('검색어를 입력해 주세요.');
		$gsf_tq.val('').focus();
		return;
	}
	location.href = '/shop/mart/martSearch.gs?supCd='+ $gsf_tq.data('supcd') +'&mq='+ encodeURIComponent(gsf_tq_val) +'&lseq=W900001-SC';
}

function fnGetUrlLseq(strLseq){
	var returnLseq = "";
	try {
		if (strLseq != "") {
			var lseq = strLseq.split(",");
			if (lseq.length > 2) {
				if (location.pathname.indexOf("main.gs") > -1) {	//메인
					returnLseq = lseq[0];
				} else if (location.pathname.indexOf("section.gs") > -1) {	//카테고리
					returnLseq = lseq[1];
				} else if (location.pathname.indexOf("pmo.gs") > -1) {	//행사
					returnLseq = lseq[2];
				} else if (location.pathname.indexOf("martSearch.gs") > -1) {	//검색
					returnLseq = lseq[3]||'';
				}
			}
		}
	}catch (e) {}
return returnLseq;
}